

/**
 * Extracts only the values corresponding to stateKeys from the response data.
 */
export function extractRelevantData<Entity extends Object, keys extends (keyof Entity)[]>(
    data: Array<Entity> | Entity,
    stateKeys: keys
): Partial<Entity> {
    if (Array.isArray(data)) {
        if (data.length === 0) return {}; // If empty array, return empty object
        return extractFromObject(data[0], stateKeys); // Use the first object
    }
    return extractFromObject(data, stateKeys);
}

/**
 * Helper function to extract only specified keys from an object.
 */
export function extractFromObject<Entity extends Object, Key extends keyof Entity>(
    obj: Entity,
    keys: Array<Key>
): Partial<Entity> {
    return keys.reduce((acc, key) => {
        if (key in obj) acc[key] = obj[key];
        return acc;
    }, {} as Partial<Entity>);
}